module.exports = __webpack_public_path__ + "img/faccess_logo.67b07aac.svg";